import { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setCurrentQuestionIndex, setAnswer, decrementTime, setTimeLeft } from '../../store/slice/exam/exam.slice'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import BreadCrumbs from '../breadcrumb/Breadcrumb'
import Button from '../button/Button'
import './StudentPractice.scss'
import './StudentExamTest.scss'
import { postExamAnswer, publishExamResult, setEndExam } from '../../store/builders/student/student.builder'
import dayjs from 'dayjs'

function StudentExamTest() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { studentOnlineExamQuestions } = useSelector((state) => state.student)
  const currentQuestionIndex = useSelector((state) => state.exam.currentQuestionIndex)
  const questions = studentOnlineExamQuestions?.studentExamList
  const { timeLeft, endExam, answers } = useSelector((state) => state.exam)
  const timeLeftFlag = useRef(false)
  
  const [currentQuestion, setCurrentQuestion] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)
  const [finishStatus, setFinishStatus] = useState(false)

  const endTime = studentOnlineExamQuestions?.studentExamList?.[0]?.timetable?.endTime
  const studentId = studentOnlineExamQuestions?.studentExamList?.[0]?.studentId
  const timetableId = studentOnlineExamQuestions?.studentExamList?.[0]?.timetableId

  useEffect(() => {
    if (questions) {
      questions.map((question)=>{
        if(question.answer !== null){
            dispatch(setAnswer({ questionId: question?.student_online_exam_paper_id, answer: question?.answer }))
        }
      })
      const firstUnansweredIndex = questions.findIndex((question) => question.answer === null)
      if (firstUnansweredIndex !== -1) {
        dispatch(setCurrentQuestionIndex(firstUnansweredIndex))
      }
    }
  }, [questions, dispatch])

  const onBackButtonEvent = (e) => {
    e.preventDefault()
    if (!finishStatus) {
      if (window.confirm('Do you want to end exam?')) {
        setFinishStatus(true)
    dispatch(setEndExam({ timetableId: currentQuestion?.timetableId, endExam: true }))
        clearExam(dispatch)
        const data = {
          answer: selectedOption,
          remainingTime: `${timeLeft}`,
          answerTime: dayjs().format('hh:mm A'),
        }
        if (data.answer) {
          dispatch(
            postExamAnswer({
              data,
              studentOnlineExamPaperId: currentQuestion?.student_online_exam_paper_id,
            }),
          )
        }
        navigate('/dashboard')
      } else {
        window.history.pushState(null, null, window.location.pathname)
        setFinishStatus(false)
      }
    }
  }

  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', onBackButtonEvent)
    return () => {
      window.removeEventListener('popstate', onBackButtonEvent)
    }
  }, [currentQuestion, selectedOption])

  useEffect(() => {
    const totalExamTimeInSeconds = studentOnlineExamQuestions?.remainingTime
    const currentTime = dayjs()
    const examEndTime = dayjs(endTime, 'hh:mm A')
    const timeDifference = examEndTime.diff(currentTime, 'second')
    if (timeDifference < totalExamTimeInSeconds) {
      dispatch(setTimeLeft(Math.max(timeDifference, 0)))
    } else if (endExam) {
      dispatch(setTimeLeft(totalExamTimeInSeconds))
    } else {
      dispatch(setTimeLeft(timeLeft))
    }
  }, [endExam, dispatch, studentOnlineExamQuestions?.remainingTime, timeLeft, endTime])

  useEffect(() => {
    if (timeLeft === 0 && !timeLeftFlag.current && !endExam) {
      timeLeftFlag.current = true
      const data = {
        answer: selectedOption,
        remainingTime: `${timeLeft}`,
        answerTime: dayjs().format('hh:mm A'),
      }
      if (data.answer) {
        dispatch(
          postExamAnswer({
            data,
            studentOnlineExamPaperId: currentQuestion?.student_online_exam_paper_id,
          }),
        )
      }
      dispatch({ type: 'exam/clearExtraReducers' })
      navigate('/dashboard')
    }
  }, [timeLeft])

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(decrementTime())
    }, 1000)
    return () => clearInterval(timer)
  }, [dispatch])

  useEffect(() => {
    if (currentQuestionIndex >= 0 && questions) {
      setCurrentQuestion(questions[currentQuestionIndex])
    }
  }, [currentQuestionIndex, questions])

  const breadCrumbsArr = [
    {
      title: 'Exam',
      link: null,
    },
    {
      title: 'Dashboard',
      link: ROUTES_PATH.STUDENT_DASHBOARD,
    },
    {
      title: 'Exam',
      link: ROUTES_PATH.STUDENT_EXAM_TEST,
    },
    {
      title: 'US Accounting',
      link: ROUTES_PATH.STUDENT_EXAM_TEST,
    },
  ]

  const clearExam = (dispatch) => {
    dispatch({ type: 'exam/clearExtraReducers' })
  }

  const handleBtnClick = () => {
    dispatch(setEndExam({ timetableId: currentQuestion?.timetableId , endExam: true}))
    clearExam(dispatch)
    const data = {
      answer: selectedOption,
      remainingTime: `${timeLeft}`,
      answerTime: dayjs().format('hh:mm A'),
      // timetableId: currentQuestion.timetableId,
    }
    if (data.answer) {
      dispatch(
        postExamAnswer({
          data,
          studentOnlineExamPaperId: currentQuestion?.student_online_exam_paper_id,
        }),
      )
      dispatch(
        publishExamResult({
          studentId,
          timetableId,
        }),
      )
    }
    navigate('/dashboard')
  }

  const handleNext = () => {
    const data = {
      answer: selectedOption,
      remainingTime: `${timeLeft}`,
      answerTime: dayjs().format('hh:mm A'),
      // timetableId: currentQuestion.timetableId,
    }
    if (data.answer) {
      dispatch(
        postExamAnswer({
          data,
          studentOnlineExamPaperId: currentQuestion?.student_online_exam_paper_id,
        }),
      )
    }
    if (currentQuestionIndex < questions.length - 1) {
      dispatch(setCurrentQuestionIndex(currentQuestionIndex + 1))
    }
  }

  const handlePrevious = () => {
    if (currentQuestionIndex > 0) {
      dispatch(setCurrentQuestionIndex(currentQuestionIndex - 1))
    }
  }

  const handleOptionSelect = (option) => {
    setSelectedOption(option)
    dispatch(setAnswer({ questionId: currentQuestion?.student_online_exam_paper_id, answer: option }))
  }

  const handleTextChange = (event) => {
    const { value } = event.target
    dispatch(setAnswer({ questionId: currentQuestion?.student_online_exam_paper_id, answer: value }))
  }

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600)
    const minutes = Math.floor((timeInSeconds % 3600) / 60)
    const seconds = timeInSeconds % 60
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }

  const getButtonClass = (option) => {
    const className = 'option-child'
    const selectedOption = answers[currentQuestion?.student_online_exam_paper_id]

    if (selectedOption === option) {
      return `${className} selected`
    }

    return className
  }

  const isNextDisabled = () => {
    const answer = answers[currentQuestion?.student_online_exam_paper_id]
    if (timeLeft === 0) {
      return true
    }
    if (currentQuestionIndex === questions?.length - 1) {
      return true
    }
    if (currentQuestion?.option1 || currentQuestion?.option2 || currentQuestion?.option3 || currentQuestion?.option4) {
      return !answer
    }
    if (currentQuestion?.text !== undefined) {
      return !answer?.trim()
    }
    return false
  }

  return (
    <div className='student-practice-exam-main-div'>
      <header className='practice-exam-header'>
        <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
        <div>
          <p className='practice-exam-timer'>{formatTime(timeLeft)}</p>
        </div>
        <div>
          <Button customClassName='practice-endexam-btn' onClick={handleBtnClick}>
            End Exam
          </Button>
        </div>
      </header>

      <div className='practice-question-div'>
        <div className='practice-question-div-header'>
          <div>
            <p className='us-accounting'>US Accounting</p>

            <div className='que-ans-flex-div'>
              <div className='question'>
                <div className='practiceExam-Que-number-div'>
                  <p>{currentQuestionIndex + 1}</p>
                </div>
                <div className='practiceExam-Que-question-div'>
                  <span>{currentQuestion?.question}</span>
                </div>
              </div>

              {currentQuestion?.option1 ||
              currentQuestion?.option2 ||
              currentQuestion?.option3 ||
              currentQuestion?.option4 ? (
                <div className='Options-div-parent'>
                  {[
                    currentQuestion?.option1,
                    currentQuestion?.option2,
                    currentQuestion?.option3,
                    currentQuestion?.option4,
                  ].map((option, index) => (
                    <div className='option' key={index}>
                      <p>{String.fromCharCode(65 + index)}</p>
                      <button className={getButtonClass(option)} onClick={() => handleOptionSelect(option)}>
                        <span>{option}</span>
                      </button>
                    </div>
                  ))}
                </div>
              ) : null}

              {currentQuestion?.text !== undefined ? (
                <div className='exam-answer'>
                  <p>Ans</p>
                  <div className='exam-answer-textarea'>
                    <textarea
                      name='Text'
                      value={answers[currentQuestion?.student_online_exam_paper_id] || ''}
                      onChange={handleTextChange}
                      className='textarea'
                      placeholder='Type your answer here...'
                      rows={8}
                    ></textarea>
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          <footer className='practice-exam-footer'>
            <p className='practice-exam-footer-currentQuestion'>
              <span>{String(currentQuestionIndex + 1)?.padStart(2, '0')}</span> /{' '}
              {String(questions?.length)?.padStart(2, '0')}
            </p>
            <span className='exam-deadline'>
              {/* You have {studentOnlineExamQuestions.remainingTime} minutes to complete this. */}
            </span>
            <div className='btn'>
              <Button
                customClassName={'btn-Previous'}
                onClick={handlePrevious}
                disabled={currentQuestionIndex === 0 || timeLeft === 0}
              >
                Previous
              </Button>
              <Button customClassName={'btn-Next'} onClick={handleNext} disabled={isNextDisabled()}>
                {UI_CONSTANT.NEXT}
              </Button>
            </div>
          </footer>
        </div>
      </div>
    </div>
  )
}

export default StudentExamTest
